import { RequestError } from 'lib/errors/errors.js';

export function fetchCreative(url, options = {}) {
  return fetch(url, options)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      if (response.statusText) {
        throw new RequestError(response);
      } else {
        return response.json();
      }
    })
    .then((payload) => {
      if (payload.result === 'ok' && payload.data) {
        return payload.data;
      }

      throw new RequestError({
        status: payload.code || 500,
        statusText: payload.message || 'Data unavailable',
        url,
      });
    });
}
